export default __webpack_public_path__ + "static/media/thai-flag.f221b4a4.svg";